import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingHeicToJpgConfig } from '@/data/landingConfig/landingHeicToJpgConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_HeicToJpg } from './schemaObject';

interface Props {}
const HeicToJpgConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_HeicToJpg} />
			<LandingTemplate
				data={landingHeicToJpgConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default HeicToJpgConverter;
